import { useState } from 'react';

import { Paper, InputBase, IconButton } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

type Params = {
    handleValue: (e: string) => void;
    showTab: (e: boolean) => void;
}

const InputSearch = ({ handleValue, showTab }: Params) => {
    const [searchInput, setSearchInput] = useState('');

    const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();

            searchInput && handleValue(searchInput);
        }
    }

    const handleOnchange = (e: string) => {
        setSearchInput(e);
        e?.length > 0 ? showTab(false) : showTab(true);
        e?.length > 0 && handleValue(searchInput);
    }

    return (
        <Paper
            component="form"
            sx={{
                paddingLeft: '1.3125rem',
                marginTop: '.5rem',
                height: '43px',
                display: 'flex',
                alignItems: 'center',
                boxShadow: 'none',
                border: '1px solid #8D9BB5',
                borderRadius: '7px'
            }}
        >
            <InputBase
                sx={{ flex: 1, fontSize: '.9375rem' }}
                value={searchInput}
                onChange={(e) => handleOnchange(e.target.value)}
                placeholder="Pesquise aqui a sua dúvida"
                inputProps={{ 'aria-label': 'Pesquise aqui a sua dúvida' }}
                onKeyPress={handleKeyDown}
            />
            <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={() => searchInput && handleValue(searchInput)}>
                <SearchIcon />
            </IconButton>
        </Paper>
    );
}

export default InputSearch;